import React from "react";
import { ToastContainer } from "react-toastify";
import "./QPRToast.css";

const QPRToast = () => {
  return <ToastContainer />;
};

export default QPRToast;
